import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'start.learning.description': {
    id: 'start.learning.description',
        defaultMessage: 'Join the platform to access exclusive content for pharmacists',
        description: 'Junte-se � plataforma e descubra conte�dos exclusivos para farmac�uticos',
  },
  'start.learning': {
    id: 'start.learning',
    defaultMessage: 'Start learning',
    description: 'Header text for logistration MFE pages',
  },
  'with.site.name': {
    id: 'with.site.name',
    defaultMessage: 'with {siteName}',
    description: 'Header text with site name for logistration MFE pages',
  },
});

export default messages;
